import { Link } from "react-router-dom";

const ThankYou = () => {
  return (
    <div className="min-h-screen bg-[#fdf6ee] flex items-center justify-center px-4 font-sans text-center">
      <div className="max-w-md space-y-6">
        <h1 className="text-4xl font-extrabold text-[#FF5A5F]">
          Thank You for Signing Up! 🎉
        </h1>
        <p className="text-lg text-black/80 leading-relaxed">
          We’ve received your information. A member of the FullPlateNow team
          will reach out shortly to guide you through onboarding and setup.
        </p>
        <p className="text-sm text-gray-500">
          Need help sooner? Email us at{" "}
          <a
            href="mailto:support@fullplatenow.com"
            className="underline text-black hover:text-[#FF5A5F] transition"
          >
            support@fullplatenow.com
          </a>
        </p>

        <Link to="/">
          <button className="mt-4 px-6 py-3 bg-black text-white rounded-full hover:bg-gray-900 transition">
            Back to Homepage
          </button>
        </Link>
      </div>
    </div>
  );
};

export default ThankYou;
